const PREFIX = "Shared/Modal/";

export const OPEN_MODAL = `${PREFIX}OPEN_MODAL`;
export const CLOSE_ACTIVE_MODAL = `${PREFIX}CLOSE_ACTIVE_MODAL`;
export const UNRENDER_ACTIVE_MODAL = `${PREFIX}UNRENDER_ACTIVE_MODAL`;
export const UPDATE_MODAL_CONTEXT = `${PREFIX}UPDATE_MODAL_CONTEXT`;
